import { useCallback, useState } from "react";
import { useGlobalContext } from "../Context/GlobalContext";

const useBanner = () => {
  // Initial true so first render se hi shimmer show ho
  const [loading, setLoading] = useState(true);
  const [banners, setBanners] = useState([]);

  const { api } = useGlobalContext();

  const fetchBanners = useCallback(async () => {
    setLoading(true);

    try {
      // =====================================================
      // CURRENT LOCATION
      // =====================================================

      const getCurrentLocation = () => {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject(new Error("Geolocation is not supported by this browser."));

            return;
          }

          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve({
                latitude: String(position.coords.latitude),

                longitude: String(position.coords.longitude),
              });
            },

            (error) => {
              reject(error);
            },

            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0,
            },
          );
        });
      };

      // Shimmer remains visible while location is being fetched
      const { latitude, longitude } = await getCurrentLocation();

      // =====================================================
      // PAYLOAD
      // =====================================================

      const payload = {
        latitude,
        longitude,
      };

      console.log("Banner API payload:", payload);

      // =====================================================
      // API
      // =====================================================

      const response = await api.post("/Chaafo/getAppBanner", payload);

      // =====================================================
      // RESPONSE
      // =====================================================

      if (response?.data?.responseCode === "00") {
        const bannerData = Array.isArray(response?.data?.response)
          ? response.data.response.filter(
              (banner) => banner?.banner_position === "AFTER_FAST_DELIVERY",
            )
          : [];

        setBanners(bannerData);
      } else {
        setBanners([]);
      }
    } catch (error) {
      console.error("Banner API Error:", error);

      setBanners([]);
    } finally {
      // Hide shimmer only after complete process finishes
      setLoading(false);
    }
  }, [api]);

  return {
    loading,
    banners,
    fetchBanners,
  };
};

export default useBanner;
